import { UIState } from "@hydra/core/uiState";
import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class OverflowDetection implements Plugin {
  sectionName!: string;
  elementWidth!: number;
  hasOverflowed: boolean = false;

  constructor(private readonly element: HTMLElement) {
    this.sectionName = element.dataset.name || "undefined";
  }

  private readonly resizeListener = () => this.checkOverflow();

  init(): void {
    this.elementWidth = this.element.offsetWidth;
    window.addEventListener("resize", this.resizeListener);
    this.checkOverflow();
  }

  destroy(): void {
    window.removeEventListener("resize", this.resizeListener);
  }

  checkOverflow = (): void => {
    setTimeout(() => {
      const uiState = UIState.getInstance();

      this.hasOverflowed = this.elementWidth > uiState.viewportWidth;

      if (this.sectionName === "header") {
        this.elementWidth = 1280;
        this.hasOverflowed = this.elementWidth > uiState.viewportWidth;
        if (uiState.isSidebarOpen) {
          if (!uiState.isSmallDevice && !this.hasOverflowed) {
            uiState.isSidebarOpen = false;
            uiState.isNavbarVisible = true;
          }
          return;
        }

        const shouldBeVisible = uiState.isSmallDevice
          ? false
          : !this.hasOverflowed;
        if (uiState.isNavbarVisible !== shouldBeVisible) {
          uiState.isNavbarVisible = shouldBeVisible;
        }
      }
    }, 0);
  };
}

PluginRegistry.register("overflow-detection", OverflowDetection);
